var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBenfitCost(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4531 23.8829C14.4531 26.0329 16.1031 27.7662 18.1531 27.7662H22.3365C24.1198 27.7662 25.5698 26.2496 25.5698 24.3829C25.5698 22.3496 24.6865 21.6329 23.3698 21.1662L16.6531 18.8329C15.3365 18.3662 14.4531 17.6496 14.4531 15.6162C14.4531 13.7496 15.9031 12.2329 17.6865 12.2329H21.8698C23.9198 12.2329 25.5698 13.9662 25.5698 16.1162",
    stroke: "url(#paint0_linear_33_618)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10V30",
    stroke: "url(#paint1_linear_33_618)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0003 36.6668H15.0003C6.66701 36.6668 3.33368 33.3335 3.33368 25.0002V15.0002C3.33368 6.66683 6.66701 3.3335 15.0003 3.3335H25.0003C33.3337 3.3335 36.667 6.66683 36.667 15.0002V25.0002C36.667 33.3335 33.3337 36.6668 25.0003 36.6668Z",
    stroke: "url(#paint2_linear_33_618)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_33_618",
    x1: 20.0115,
    y1: 12.2329,
    x2: 20.0115,
    y2: 27.7662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53A6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_33_618",
    x1: 20.5,
    y1: 10,
    x2: 20.5,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53A6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_33_618",
    x1: 20.0003,
    y1: 3.3335,
    x2: 20.0003,
    y2: 36.6668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53A6FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenfitCost);
export default __webpack_public_path__ + "static/media/benfit-cost.6dc764b44cd5b77acfae6284bf725425.svg";
export { ForwardRef as ReactComponent };